export const states = [
    "AC",
    "AL",
    "AM",
    "AP",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MG",
    "MS",
    "MT",
    "PA",
    "PB",
    "PE",
    "PI",
    "PR",
    "RJ",
    "RN",
    "RO",
    "RR",
    "RS",
    "SC",
    "SE",
    "SP",
    "TO",
];

export const confirmationOptions = ["Sim", "Não"];

export const genderOptions = [
    "Homem",
    "Mulher",
    "Mulher Trans",
    "Homem Trans",
    "Travesti",
    "Transexual",
    "Queer",
    "Não-binário",
    "Gênero fluido",
    "Transgênero",
    "Prefiro não responder",
    "Outro(a)",
];
